import React from 'react';
import { Link } from 'react-router-dom';
import { categoryImageUrl } from '../data/categoryImageUrl';
import { responsiveImage, COVER_WIDTHS } from '../data/responsiveImage';
import { CREAM } from '../theme';
import '../Landing/Landing.css';

export default function CategoriesIndexView({ categories }) {
  return (
    <div>
      <section style={{ padding: 'clamp(48px,7vh,80px) clamp(36px,7vw,130px) clamp(24px,4vh,40px)' }}>
        <nav aria-label="Breadcrumb" style={{ fontSize: 13, letterSpacing: '.14em', textTransform: 'uppercase', color: 'rgba(239,228,210,.55)', marginBottom: 16 }}>
          <Link to="/#categories" style={{ color: 'inherit', textDecoration: 'none' }}>Home</Link>
          <span aria-hidden="true" style={{ fontSize: 18, margin: '0 8px' }}>›</span>
          <span aria-current="page" style={{ color: CREAM }}>Categories</span>
        </nav>
        <h1 style={{ fontFamily: "'Bodoni Moda', serif", fontStyle: 'italic', fontWeight: 500, fontSize: 'clamp(38px,5.4vw,64px)', margin: 0, color: CREAM }}>All Categories</h1>
      </section>

      <section style={{ padding: '0 clamp(36px,7vw,130px) clamp(60px,9vh,100px)' }}>
        {categories.length === 0 ? (
          <p style={{ color: 'rgba(239,228,210,.55)' }}>No categories published yet.</p>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 240px), 1fr))', gap: 'clamp(24px,3vw,40px)', maxWidth: categories.length < 4 ? categories.length * 400 : 'none' }}>
            {categories.map((cat) => {
              const cover = cat.coverImage;
              return (
                <Link
                  key={cat.slug}
                  to={`/categories/${cat.slug}`}
                  className="ij-cat-card"
                  style={{ textDecoration: 'none', display: 'block', color: 'inherit' }}
                >
                  <div style={{ position: 'relative', width: '100%', aspectRatio: '4 / 5', background: 'repeating-linear-gradient(135deg,#3a2418,#3a2418 14px,#301c12 14px,#301c12 28px)', border: '1px solid rgba(226,190,118,.35)', overflow: 'hidden' }}>
                    {cover && (
                      <img
                        {...responsiveImage(categoryImageUrl(cover), COVER_WIDTHS, '(max-width: 640px) 92vw, (max-width: 1100px) 46vw, 22vw')}
                        alt=""
                        loading="lazy"
                        decoding="async"
                        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top' }}
                      />
                    )}
                  </div>
                  {/* Caption sits below the cover, matching the homepage grid.
                      Overlaid, these labels had to survive covers ranging from
                      a near-black bridal green to a pale sage — no single
                      scrim treatment held all of them. */}
                  <div style={{ marginTop: 16 }}>
                    <h3 style={{ fontFamily: "'Bodoni Moda', serif", fontWeight: 500, fontSize: 'clamp(26px,2.8vw,34px)', lineHeight: 1, margin: '0 0 6px', color: CREAM }}>{cat.name}</h3>
                    <span style={{ fontSize: 14, letterSpacing: '.16em', textTransform: 'uppercase', color: 'rgba(243,234,214,.62)' }}>{cat.dresses.length} piece{cat.dresses.length === 1 ? '' : 's'}</span>
                  </div>
                </Link>
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
}
